import { PHeadline, PGridItem, PText, PSpinner } from '@porsche-design-system/components-react'
import clsx from 'clsx'
import React from 'react'

import { ReportingContext } from '../../../utils/Context/ReportingContext'
import ContentSection from '../../Content/Main/Section/ContentSection'

import { PortalContext, UserRole } from '../../../utils/PortalContext'

import styles from './header.module.css'

type Props = {
  loading?: boolean
}

const Header: React.FC<Props> = ({ loading }) => {
  const defaultApplication = 'Alle Applikationen'
  const { userRole } = React.useContext(PortalContext)
  const { contentHeader, setContentHeader } = React.useContext(ReportingContext)

  React.useEffect(() => {
    if (contentHeader === '' && userRole === UserRole.ApplicationManager) {
      setContentHeader('Alle Applikationen')
    } else if (contentHeader === '' && (userRole === UserRole.Manager || userRole === UserRole.KeyUser)) {
      setContentHeader('Alle Abteilungen')
    } else {
      setContentHeader(contentHeader)
    }
  }, [])

  return (
    <PGridItem size={12}>
      <PHeadline variant='headline-5'>Reporting</PHeadline>
      <ContentSection className={clsx(styles.content, { [styles.loading]: loading })}>
        <PHeadline variant='headline-3'>{contentHeader}</PHeadline>
        <PText>Ansicht</PText>
        {loading && <PSpinner className={styles.spinner} />}
      </ContentSection>
    </PGridItem>
  )
}
export default Header
